<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <!--page content-->
            <div class="admin-page-content par-request-list">
                <div class="mb-2 page-title-container">
                    <div class="page-name">PAR Request List</div>
                </div>
                <div class="pl-0 pr-0 col-md-12 forms-block" style="margin-bottom: 20px; float: left; width: 100%;">
                    <div class="pl-0 col-md-6 col-sm-12 forms-block pr-0 pull-left">
                        <div class="mt-2 pull-left pr-0 pl-0 col-3 paddingleft0">
                            <div class="form-label">Reason :</div>
                        </div>
                        <div class="pull-right pr-0 pl-0 col-9 paddingleft0 multi-select-par">
                            <v-select v-model="reasonType" name="reasonType"
                                multiple
                                label="text"
                                :options="reasonTypeArr" :clearable=false>
                            </v-select>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 pl-0 pr-0 forms-block pull-right">
                        <div class="page-title-container">
                            <div class="pagebutton">
                                <router-link class="themebutton" title="PAR Request" v-bind:to="{name: 'AddUpdatePARRequest'}">
                                    <span>Add PAR Request</span>
                                </router-link>
                                <a class="themebutton" style="margin-right: 5px; color: white;" id='exportPARRequestAll' title='Export' v-on:click.prevent="exportPARRequestList(1)">
                                    <span>Export</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="clearfix"></div>
                <vue-good-table
                    ref="PARRequestList"
                    mode="remote"
                    title="PAR Request List"
                    @on-page-change="onPageChange"
                    @on-selected-rows-change="selectionChanged"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    @on-sort-change="onSortChange"
                    :totalRows="totalRecords"
                    :columns="columns"
                    :rows="rows"
                    :selectOptions="{
                        enabled: true,
                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                        selectionInfoClass: 'custom-class',
                        selectionText: 'rows selected',
                        clearSelectionText: 'clear',
                    }"
                    :pagination-options="{
                        enabled: true,
                        mode: 'pages',
                        pageLabel: 'Page',
                        position: 'bottom',
                        perPage: serverParams.perPage,
                        setCurrentPage: serverParams.setCurrentPage,
                        perPageDropdown: [25, 50, 100, 200 ,500],
                        dropdownAllowAll: false,
                    }"
                    :search-options="{
                        enabled: false,
                    }">
                    <!-- Custome Pagination -->
                    <template slot="pagination-bottom" slot-scope="props">
                        <div class="vgt-wrap__footer crm">
                            <div  class="row">
                                <div class="col-sm-12 col-md-2 PerPage">
                                    <v-select title="Select Per Page"
                                        class="pagination-select-box"
                                        v-model="serverParams.perPage"
                                        @change="changedValueTask"
                                        @input="changedValueTaskCustomPerPageTask()"
                                        name="customPerPage"
                                        id="customPerPage"
                                        label="text"
                                        :clearable="false"
                                        :searchable="false"
                                        :filterable="false"
                                        :options="serverParams.perPageDropdown"
                                        placeholder="Select Per Page">
                                    </v-select>
                                </div>
                                <div class="mt-2 col-sm-12 col-md-2 RowsDisplay">
                                    <p class="pageRowCount">{{paginationDisplayRowsTask}} of {{totalRecords}}</p>
                                </div>
                                <div class="col-sm-12 col-md-6 Pagination">
                                    <ul class="pagination">
                                        <li class="FirstPage" title="First Page">
                                            <template v-if="Number(serverParams.page) == 1">
                                                <a class="page-link" href="javascript:void(0)">1</a>
                                            </template>
                                            <template v-else>
                                                <a v-on:click="onPerticularPageClickTask(1)" class="page-link" href="javascript:void(0)">1</a>
                                            </template>
                                        </li>
                                        <li class="page-item PreviousPage" title="Previous Page">
                                            <template v-if="Number(serverParams.page) == 1">
                                                <a class="page-link" href="javascript:void(0)" tabindex="-1"><i class="fa fa-angle-left"></i></a>
                                            </template>
                                            <template v-else>
                                                <a class="page-link" href="javascript:void(0)" tabindex="-1" v-on:click="onPerticularPageClickTask(Number(serverParams.page)-1)" ><i class="fa fa-angle-left"></i></a>
                                            </template>
                                        </li>
                                        <!--New Implementation-->
                                        <template v-if="pageNumberListTask() < displayPageTask">
                                            <template v-for="(n, index) in pageNumberListTask()">
                                                <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                    <a class="page-link" href="javascript:void(0)">
                                                        {{n}}
                                                    </a>
                                                </li>
                                                <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                    <a class="page-link" href="javascript:void(0)">
                                                        {{n}}
                                                    </a>
                                                </li>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <!--End New Implementation-->
                                            <template v-if="Number(serverParams.page) <= pageCompareTask">
                                                <template v-for="(n, index) in displayPageTask">
                                                    <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                    <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                </template>
                                            </template>
                                            <template v-else-if="Number(serverParams.page) >= (pageNumberListTask() - (pageCompareTask-1))">
                                                <template v-for="(n, index) in pageNumberListTask()">
                                                    <template v-if="n > (pageNumberListTask() - displayPageTask)">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <template v-for="(n, index) in pageNumberListTask()" v-if="(n >= (Number(serverParams.page) - (pageCompareTask -1))) && (n <= (Number(serverParams.page) + (pageCompareTask -1)))">
                                                    <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                    <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                </template>
                                            </template>
                                        </template>
                                        <li class="page-item NextPage" title="Next Page">
                                            <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                <a class="page-link" href="javascript:void(0)"><i class="fa fa-angle-right"></i></a>
                                            </template>
                                            <template v-else>
                                                <a class="page-link" href="javascript:void(0)" v-on:click="onPerticularPageClickTask(Number(serverParams.page)+1)"><i class="fa fa-angle-right"></i></a>
                                            </template>
                                        </li>
                                        <li class="LastPage" title="Last Page">
                                            <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                <a class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                            </template>
                                            <template v-else>
                                                <a v-on:click="onPerticularPageClickTask(pageNumberListTask())" class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                            </template>
                                        </li>
                                    </ul>
                                </div>
                                <div class="mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                    <p class="pageJumpLabel">Page : </p>
                                </div>
                                <div class="mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                    <input @keyup.enter="jumpToPageInTask" v-model="jumpToPageTask" type="text" class="form-control form-control-sm" name="jumpToPageTask" id="jumpToPageTask" placeholder="Page">
                                </div>
                            </div>
                        </div>
                    </template>
                    <!-- End Custome Pagination -->
                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                        <div :key="key">
                            <div v-if="props.column.field == 'action'" class="table-action">
                                <template v-if="loginUserRoleId == 1 || loginUserRoleId == 2">
                                    <router-link title='Edit PAR Request' class="btn edit-btn-vvg waves-effect pull-left" v-bind:to="{name: 'UpdatePARRequest', params:{id: props.row.id}}">
                                        <i class="fa fa-pencil" aria-hidden="true"></i>
                                    </router-link>
                                </template>
                                <a href="javascript:void(0)" @click="openGallery(props.row.id)" title='View PAR Request Document' class="btn edit-btn-vvg waves-effect pull-left">
                                    <i class="fa fa-eye" aria-hidden="true"></i>
                                </a>
                                <a href="javascript:void(0)" @click="downloadDocument(props.row.id)" title='Download PAR Request Document' class="btn edit-btn-vvg waves-effect pull-left">
                                    <i class="fa fa-download" aria-hidden="true"></i>
                                </a>
                                <a v-if="permissionsArray.includes('can_delete_par_request')" href="javascript:void(0)" @click="deletePARRequest(props.row.id)" title='Delete PAR Request' class="btn edit-btn-vvg waves-effect pull-left">
                                    <i class="fa fa-trash-o" aria-hidden="true"></i>
                                </a>

                            </div>
                            <div v-else>
                                {{props.formattedRow[props.column.field]}}
                            </div>
                        </div>
                    </template>
                    <div slot="selected-row-actions" slot-scope="computed">
                        {{computed.selectedRows}}
                        <button id="exportPARRequestIdWise" v-on:click.prevent="exportPARRequestList(0)" class="btn btn-success" title="Export">
                            Export {{selectedRows}} Record(s)
                        </button>
                        <button v-if="permissionsArray.includes('can_delete_par_request')" id="deletePARRequestIdWise" v-on:click.prevent="deletePARRequest(0)" class="btn btn-success" title="Delete">
                            Detele {{selectedRows}} Record(s)
                        </button>
                    </div>
                </vue-good-table>   
            </div>
            <b-modal size="lg" class="gallery_modal" id="modal1" @cancel="onCancel('main')" ref="myModalRef" hide-footer :hide-header=true :style="align">
                <img class="w-100 mb-3" :src="viewImage" :style="imageWidth">
                <div class="clearfix"></div>
                <div class="image-arrows customIconModelFooter clearfix">
                    <button type="button" class="ml-2 btn btn-primary pull-right" v-on:click="changeImage('next')"><i class="fa fa-angle-right" aria-hidden="true"></i></button>
                    <button type="button" class="ml-2 btn btn-primary pull-right" v-on:click="changeImage('previous')"><i class="fa fa-angle-left" aria-hidden="true"></i></button>
                    <button class="ml-2 btn btn-primary pull-right" type="button"  v-on:click="downloadImage(viewImage)"><i class="fa fa-download" aria-hidden="true"></i></button>
                </div>
            </b-modal>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
    var exten = ['gif', 'jpg', 'jpeg', 'png'];
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import {commonMixins} from '../../../mixins/commonMixins';
    import {HTTP} from '../../../http-common.js';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    import EventBus from "../../../components/event-bus";
    Vue.component("app-footer", Footer);
    Vue.use(VueGoodTable);
    var self;
    export default {
        name: 'ListPARRequest',
        components: {
        },
        mixins: [commonMixins],
        data() {
            return {
                firstLoad: 0,
                // reasonType: "",
                reasonType: [],
                reasonTypeArr: [],
                columns: [
                    {
                        label: 'PAR Claim#',
                        field: 'return_order',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "PAR Claim#", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Credit PO#',
                        field: 'credit_po',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Credit PO#", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Claim Status',
                        field: 'claim',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Claim Status", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'By',
                        field: 'by_par',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "By", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Date',
                        field: 'date',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "MM/DD/YYYY", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'PAR Tag#',
                        field: 'par_tag',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "PAR Tag#", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'PO#',
                        field: 'po',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "PO#", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Daimler Invoice',
                        field: 'daimler_invoice',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Daimler Invoice", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Customer Invoice Credit#',
                        field: 'customer_invoice_credit',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Customer Invoice Credit#", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Restocking Fee',
                        field: 'restocking_fee',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Restocking Fee", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Location',
                        field: 'location',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Location", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Reason',
                        field: 'reason',
                        filterable: false,
                        sortable: false,
                        /* filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Reason", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        } */
                    },
                    {
                        label: 'Manager Name',
                        field: 'manager_name',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Manager Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Updated By',
                        field: 'updated_by',
                        filterable: true,
			            sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Updated By", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Updated At',
                        field: 'updated_at',
                        filterable: true,
			            sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "MM/DD/YYYY", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Actions',
                        field: 'action',
                        html: true,
                        sortable: false,
                        thClass: 'disable-sorting',
                        width: '108px',
                    },
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    page: 1,
                    perPage: 25,
                    sort: {
                        field: 'id',
                        type: 'desc',
                    },
                    perPageDropdown : [],
                },
                displayPageTask: 7,
                jumpToPageTask: 0,
                pageCompareTask: 0,
                paginationDisplayRowsTask: '',
                exportPARRequest: false,
                extensionArr: [],
                lightboxImages: [],
                viewImage: '',
                urlDoc: '',
                index: 0,
                imageWidth: 'width: 150px !important;',
                align: 'text-align: center;',
                loginUserRoleId: 1,
                permissionsArray: [],
            }
        },
        watch: {
            reasonType: function(reasonType) {
                self.loadPARRequest();
            }
        },
        created: function () {
        },
        beforeMount: function () {
            self = this;
        },
        mounted: function () {
            self.menuActive("PARRequest");
            self.getUserPermissions();
            self.loadReasonType();
            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginUserRoleId = userJson['role'].system_id;
            }

            self.jumpToPageTask = self.serverParams.page;
            self.pageCompareTask = Math.ceil(self.displayPageTask / 2);
            $("#jumpToPageTask").on('keyup', function (e) {
                if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
                    self.jumpToInputPageTask(self.jumpToPageTask)
                }
            });

            self.serverParams.perPageDropdown.push(25);
            self.serverParams.perPageDropdown.push(50);
            self.serverParams.perPageDropdown.push(100);
            self.serverParams.perPageDropdown.push(200);
            self.serverParams.perPageDropdown.push(500);
            // self.loadPARRequest();
        },
        methods: {
            loadReasonType: function() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                    params: {
                    }
                };
                HTTP.get("/reason/type/get", config)
                        .then(function (response) {
                            self.reasonTypeArr = response.data.content;
                            self.loadPARRequest();
                            // self.reasonType[0] = {text: self.reasonTypeArr[0].text, value: self.reasonTypeArr[0].value};
                        })
                        .catch(function (err) {
                            self.catchHandler(err, function () {});
                        });
            },
            openGallery: function (id) {
                var arr = [];
                self.extensionArr = [];
                var new_index = 0;
                $.each(self.rows, function (i) {
                    $.each(self.rows[i]['document'], function (j) {
                        if(id == self.rows[i]['document'][j].id) {
                            arr.push(self.rows[i]['document'][j].media_path);
                            self.extensionArr.push(self.rows[i]['document'][j].doc_extension);
                        }
                    });
                });
                self.loadImagesInLightBox(arr, 0);
            },
            loadImagesInLightBox: function (arr, index) {
                var self = this;
                self.lightboxImages = arr;
                self.index = index;
                self.viewImage = self.lightboxImages[self.index];
                self.urlDoc = self.lightboxImages[self.index];
                self.imageWidth = 'width: 150px !important;';
                self.align = 'text-align: center;';
                if(self.extensionArr[self.index].toLowerCase() == 'gif' || self.extensionArr[self.index].toLowerCase() == 'jpg' || self.extensionArr[self.index].toLowerCase() == 'jpeg' || self.extensionArr[self.index].toLowerCase() == 'png') {
                    self.imageWidth = '';
                    self.align = '';
                } else if(self.extensionArr[self.index].toLowerCase() == 'doc' || self.extensionArr[self.index].toLowerCase() == 'docx') {
                    self.viewImage = '';
                    self.viewImage = "/static/images/doc-icon.png";
                } else if(self.extensionArr[self.index].toLowerCase() == 'xls' || self.extensionArr[self.index].toLowerCase() == 'xlsx') {
                    self.viewImage = '';
                    self.viewImage = "/static/images/xl-icon.png";
                } else if(self.extensionArr[self.index].toLowerCase() == 'ppt' || self.extensionArr[self.index].toLowerCase() == 'pptx') {
                    self.viewImage = '';
                    self.viewImage = "/static/images/ppt-icon.png";
                } else if(self.extensionArr[self.index].toLowerCase() == 'pdf') {
                    self.viewImage = '';
                    self.viewImage = "/static/images/pdf-icon.png";
                } else {
                    self.viewImage = '';
                    self.viewImage = "/static/images/link-icon.png";
                }
                self.$refs.myModalRef.show();
            },
            onCancel: function (type) {
            },
            changeImage: function (move) {
                var self = this;
                if (move == 'next') {
                    self.index = self.index + 1;
                    if (self.lightboxImages.length <= self.index) {
                        self.index = 0;
                    }
                } else {
                    self.index = self.index - 1;
                    if (self.index < 0) {
                        self.index = (self.lightboxImages.length - 1);
                    }
                }
                self.urlDoc = self.lightboxImages[self.index];
                self.imageWidth = 'width: 150px !important;';
                self.align = 'text-align: center;';
                if(self.extensionArr[self.index].toLowerCase() == 'gif' || self.extensionArr[self.index].toLowerCase() == 'jpg' || self.extensionArr[self.index].toLowerCase() == 'jpeg' || self.extensionArr[self.index].toLowerCase() == 'png') {
                    self.imageWidth = '';
                    self.align = '';
                    self.viewImage = self.lightboxImages[self.index];
                } else if(self.extensionArr[self.index].toLowerCase() == 'doc' || self.extensionArr[self.index].toLowerCase() == 'docx') {
                    self.viewImage = "/static/images/doc-icon.png";
                } else if(self.extensionArr[self.index].toLowerCase() == 'xls' || self.extensionArr[self.index].toLowerCase() == 'xlsx') {
                    self.viewImage = "/static/images/xl-icon.png";
                } else if(self.extensionArr[self.index].toLowerCase() == 'ppt' || self.extensionArr[self.index].toLowerCase() == 'pptx') {
                    self.viewImage = "/static/images/ppt-icon.png";
                } else if(self.extensionArr[self.index].toLowerCase() == 'pdf') {
                    self.viewImage = "/static/images/pdf-icon.png";
                } else {
                    self.viewImage = "/static/images/link-icon.png";
                }
            },
            downloadImage: function (filepath) {
                if(self.imageWidth != '') {
                    // window.open(self.urlDoc, 'Download');
                    window.open(self.urlDoc, '_blank');
                } else {
                    // window.open(filepath, 'Download');
                    window.open(filepath, '_blank');
                }
            },
            downloadDocument: function(id) {
                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("tkn")
                    },
                    params : {
                        id : id
                    }
                };
                self.showLoader();
                HTTP.get('/par/request/download/attachment', config)
                    .then(response => {
                        if(response.data.code == 200) {
                            location.href = response.data.content.zip_file;
                        }
                        self.hideLoader();
                    })
                    .catch(function (err) {
                        self.hideLoader();
                        self.catchHandler(err, function () {});
                    });
            },
            jumpToPageInTask: function (e) {
                self.jumpToInputPageTask(self.jumpToPageTask);
            },
            changedValueTaskCustomPerPageTask: function () {
                self.jumpToInputPageTask(self.serverParams.page);
                self.loadPARRequest();
            },
            changedValueTask: function (value) {
                /*console.log(value);*/
            },
            pageNumberListTask: function () {
                var totalRecord = self.totalRecords;
                var count = 0;
                for (var i = 0; totalRecord > 0; i++) {
                    totalRecord = totalRecord - self.serverParams.perPage;
                    count++;
                }
                return count;
            },
            jumpToInputPageTask: function (pageNumber) {
                var reg = /^\d+$/;
                if (pageNumber <= 0 || pageNumber == '') {
                    pageNumber = 1;
                } else if (pageNumber > self.pageNumberListTask()) {
                    pageNumber = self.pageNumberListTask();
                    if (pageNumber <= 0 || pageNumber == '') {
                        pageNumber = 1;
                    }
                } else if (!String(self.jumpToPageTask).match(reg)) {
                    pageNumber = 1;
                }
                self.onPerticularPageClickTask(pageNumber);
            },
            onPerticularPageClickTask: function (pageNumber) {
                self.serverParams.page = pageNumber;
                self.jumpToPageTask = pageNumber;
                self.loadPARRequest();
            },
            updateParams(newProps) {
                self.serverParams = Object.assign({}, self.serverParams, newProps);
            },
            onPageChange(params) {
                self.updateParams({page: params.currentPage});
                self.loadPARRequest();
            },
            onPerPageChange(params) {
                if (params.currentPerPage != self.serverParams.perPage) {
                    self.updateParams({perPage: params.currentPerPage});
                    self.totalRecords = self.totalRecords;
                    self.loadPARRequest();
                }
            },
            onColumnFilter(params) {
                self.updateParams(params);
                {
                    field: ('id');
                    field: ('by');
                    field: ('date');
                    field: ('par_tag');
                    field: ('po');
                    field: ('daimler_invoice');
                    field: ('location');
                    field: ('updated_at');
                    field: ('updated_by');
                };
                self.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(self.serverParams));
                var filters = filtersPr.columnFilters;

                if (self.firstLoad == 1 || filters.id || filters.by || filters.date || filters.par_tag || filters.po || filters.daimler_invoice
                    || filters.location || filters.updated_at || filters.updated_by
                ) {
                    self.loadPARRequest();
                }
            },
            selectionChanged() {
                self.selectedRows = (self.$refs['PARRequestList'].selectedRows).length;
                /* console.log(self.selectedRows); */
            },
            onSortChange(params) {
                self.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field
                    }
                });
                self.loadPARRequest();
            },
            deletePARRequest: function(id) {
                let deleteArray = [];
                id = (id === null || typeof (id) === "undefined" || id == '' || id == 0) ? 0 : id;
                if(id != 0) {
                    deleteArray.push(id);
                } else {
                    $('#deletePARRequestIdWise').prop("disabled", true);
                    var parRequestDeleteArr = [];
                    var selectedPARRequest = this.$refs["PARRequestList"].selectedRows;
                    for (var i = 0; i < selectedPARRequest.length; i++) {
                        parRequestDeleteArr.push(this.$refs["PARRequestList"].selectedRows[i].id);
                    }
                    deleteArray = parRequestDeleteArr;
                }
                self.$swal({
                    title: '',
                    text: 'Are you sure that you want to delete this PAR Request(s)!',
                    type: 'info',
                    confirmButtonText: 'OK',
                    showCancelButton: true,
                    // showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        var config = {
                            headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                            data : {
                                deleteArr: deleteArray,
                            }
                        };

                        HTTP.delete("/par/request/delete", config)
                            .then(function (response) {
                                $('#deletePARRequestIdWise').prop("disabled", false);
                                if (response.data.code == '200') {
                                    self.loadPARRequest();
                                }
                            })
                            .catch(function (error) {
                                $('#deletePARRequestIdWise').prop("disabled", false);
                                self.catchHandler(err, function () {});
                            });
                    } else {
                        $('#deletePARRequestIdWise').prop("disabled", false);
                    }
                });
            },
            loadPARRequest() {
                // console.log(JSON.stringify(self.reasonType));
                var strReasonType = "";
                if(self.reasonType && self.reasonType.length > 0) {
                    for(var index = 0; index < self.reasonType.length; index++) {
                        var obj = self.reasonType[index];
                        strReasonType += obj['value'] + ",";
                    }
                    strReasonType = strReasonType.replace(/,\s*$/, "");
                }
                self.firstLoad = 1;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    is_export: self.exportPARRequest,
                    // reason_type: (self.reasonType == null || !self.reasonType.value) ? '' : self.reasonType.value
                    reason_type: strReasonType
                };
                self.showLoader();
                HTTP.post("/par/request/list", fields, config)
                    .then(function (response) {
                        $('#exportPARRequestAll').prop("disabled", false);
                        self.exportPARRequest = false;
                        if (response.data.code == '200') {
                            if (response.data.message == 'success export') {
                                self.downloadFile(response.data.content.web);
                                // location.href = response.data.content.web;
                                self.loadPARRequest();
                            } else {
                                self.rows = response.data.content.row;
                                self.totalRecords = response.data.content.totalRecords;
                                self.paginationDisplayRowsTask = self.getRecords(self.serverParams.page, self.serverParams.perPage, self.totalRecords);
                            }
                        }
                        self.hideLoader();
                    })
                    .catch(function (err) {
                        $('#exportPARRequestAll').prop("disabled", false);
                        self.exportPARRequest = false;
                        self.hideLoader();
                        self.catchHandler(err, function () {});
                    });
            },
            exportPARRequestList: function(allPARRequestExport) {
                if(allPARRequestExport) {
                    self.exportPARRequest = true;
                    if (self.exportPARRequest == true) {
                        $('#exportPARRequestAll').prop("disabled", true);
                        self.loadPARRequest();
                    }
                } else {
                    var parRequestArr = [];
                    var selectedUser = this.$refs["PARRequestList"].selectedRows;
                    for (var i = 0; i < selectedUser.length; i++) {
                        parRequestArr.push(this.$refs["PARRequestList"].selectedRows[i].id);
                    }
                    $('#exportPARRequestIdWise').prop("disabled", true);
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                    };
                    var fields = {
                        par_request_id_arr: parRequestArr
                    };
                    self.showLoader();
                    HTTP.post("/par/request/export", fields, config)
                        .then(function (response) {
                            $('#exportPARRequestIdWise').prop("disabled", false);
                            if (response.data.code == '200') {
                                self.downloadFile(response.data.content.web);
                                // location.href = response.data.content.web;
                                self.loadPARRequest();
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            $('#exportPARRequestIdWise').prop("disabled", false);
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
                }
            },
        },
    };
    EventBus.$on("permissions", function(isLogin, permissionArray) {
        if (typeof self != "undefined") {
            self.permissionsArray = [];
            for (var i = 0; i < permissionArray.length; i++) {
                self.permissionsArray.push(permissionArray[i].name);
            }
        }
    });
</script>


// WEBPACK FOOTER //
// src/components/Forms/PARRequest/ListPARRequest.vue